import React from 'react'
import PropTypes from 'prop-types'

import FacilityProfileV2 from 'model/facilities/facilityProfileV2'
import Provider from 'model/provider/provider'

import { Button } from 'ui/styled'
import { ButtonContainer } from './styled'

const EntitySelectButtons = ({
  entity,
  isSelected = false,
  addText = 'Add To Care Plan',
  onSelectEntity = () => {},
  onRemoveEntity = () => {}
}) => {
  if (!entity?.id) return false

  return (
    <ButtonContainer>
      {isSelected ? (
        <Button
          data-test="carePlanBuilderRemoveBtn"
          onClick={() => onRemoveEntity(entity)}
        >
          Remove
        </Button>
      ) : (
        <Button
          btntype="primary"
          data-test="carePlanBuilderAddBtn"
          onClick={() => onSelectEntity(entity)}
        >
          {addText}
        </Button>
      )}
    </ButtonContainer>
  )
}

EntitySelectButtons.propTypes = {
  entity: PropTypes.oneOfType([
    PropTypes.instanceOf(FacilityProfileV2),
    PropTypes.instanceOf(Provider)
  ]).isRequired,
  isSelected: PropTypes.bool,
  addText: PropTypes.string,
  onSelectEntity: PropTypes.func,
  onRemoveEntity: PropTypes.func
}

export default EntitySelectButtons
